import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="app__aboutus app__bg flex__center section__padding" id="about">
      <div className="app__aboutus-overlay flex__center">
        <img src={images.G} alt="G_overlay" data-aos="fade-up" />
      </div>

      <div className="app__aboutus-content flex__center">
        <div className="app__aboutus-content_about" data-aos="fade-right">
          <h1 className="headtext__cormorant">About Us</h1>
          <p className="p__opensans">
            At Giovani, we believe that dining is an art form, where every dish tells a story and every experience is crafted with care. Our restaurant is dedicated to offering an exceptional culinary journey, blending classic techniques with innovative flavors to create unforgettable meals. With a commitment to using only the finest ingredients and a passion for perfection, we strive to elevate every dining occasion to an experience of elegance and delight.
          </p>
        </div>

        <div className="app__aboutus-content_knife flex__center" data-aos="zoom-in">
          <img src={images.knife} alt="about_knife" />
        </div>

        <div className="app__aboutus-content_history" data-aos="fade-left">
          <h1 className="headtext__cormorant">Our History</h1>
          <p className="p__opensans">
            Founded in 2021, Giovani has been a beacon of fine dining and exceptional service. Our journey began with a vision to create a space where luxury and gastronomy converge. From our humble beginnings, we have grown into a renowned establishment celebrated for its sophisticated cuisine and impeccable service. Each chapter of our history reflects our unwavering dedication to excellence and our passion for creating memorable dining experiences.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
